/** Every single-choice dropdown of the X Ads screens — the CRM's SearchableSelect (search box, numbered rows, ✓). */
import { SearchableSelect } from '@/components/SearchableSelect';

export type XSelectOption = { value: string; label: string; disabled?: boolean };

export function XSelect({ id, value, onChange, options, placeholder, disabled, className, clearable = false, numberItems = true }: {
  id?: string; ariaLabel?: string; value: string; onChange: (value: string) => void; options: XSelectOption[];
  /** shown while nothing is chosen (also while the list is still loading) */
  placeholder?: string; disabled?: boolean; className?: string;
  /** the ✕ in the field: only for lists whose empty value is a real choice ("Any") */
  clearable?: boolean;
  /** off for a list made of numbers itself */
  numberItems?: boolean;
}) {
  // Two equal labels get their value added so rows stay distinguishable.
  const seen = new Map<string, number>();
  options.forEach((o) => seen.set(o.label, (seen.get(o.label) ?? 0) + 1));
  const rows = options.map((o) => ((seen.get(o.label) ?? 0) > 1 ? { ...o, label: `${o.label} (${o.value})` } : o));
  return <SearchableSelect id={id} value={value} onChange={onChange} options={rows} placeholder={placeholder} searchPlaceholder="Search…"
    disabled={disabled} className={className} clearable={clearable} numbered={numberItems} searchable={rows.length > 6} />;
}
